module.exports = __webpack_public_path__ + "img/sales.7b16cb10.svg";